import { Drawer, IconButton } from '@mui/material'
import { isNilOrEmpty } from 'ramda-adjunct'
import { pathOr } from 'ramda'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import React, { useEffect, useState } from 'react'

import STORE_NAMESPACES from 'store/namespaces'
import useIsBelowBreakpoint from 'hooks/useIsBelowBreakpoint'

import { node } from 'prop-types'
import HeaderNav from './HeaderNav'
import MenuProfile from './MenuProfile'
import useStyles from './styles'

const Header = ({ logo }) => {
  const classes = useStyles()
  const location = useLocation().pathname
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { profile, token } = useSelector(
    state => state[STORE_NAMESPACES.SECURITY],
  )
  const isBelowMd = useIsBelowBreakpoint('md')

  const userName = pathOr('User', ['claims', 'name'], profile)

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  })

  return (
    <header
      className={classNames(classes.header, {
        [classes.headerDefault]: !token,
      })}
    >
      <div
        className={classNames(classes.headerLeft, {
          [classes.headerLeftDefault]: !token,
        })}
      >
        {isBelowMd && !isNilOrEmpty(token) && location !== '/auth/logout' ? (
          <>
            <IconButton onClick={() => setIsMenuOpen(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="left"
              open={isMenuOpen}
              onClose={() => setIsMenuOpen(false)}
              classes={{ paper: classes.drawer }}
            >
              <IconButton
                className={classes.closeDrawer}
                onClick={() => setIsMenuOpen(false)}
                size="large"
              >
                <CloseIcon />
              </IconButton>
              <HeaderNav setIsMenuOpen={setIsMenuOpen} />
            </Drawer>
          </>
        ) : (
          <img src={logo} alt="AC Environnement" className={classes.logo} />
        )}
      </div>

      {!isNilOrEmpty(token) && location !== '/auth/logout' && (
        <>
          <div className={classes.headerMiddle}>
            {isBelowMd ? (
              <img src={logo} alt="AC Environnement" className={classes.logo} />
            ) : (
              <HeaderNav />
            )}
          </div>

          <div className={classes.headerRight}>
            <MenuProfile userName={userName} />
          </div>
        </>
      )}
    </header>
  )
}

Header.propTypes = {
  logo: node.isRequired,
}

export default Header
